var map = {
	"./Orange-to-green-background.png": [
		8820,
		820
	],
	"./Orange-to-green-background.uchc.png": [
		6575,
		575
	],
	"./Orange-to-green-background.uis.png": [
		7095,
		95
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9799;
module.exports = webpackAsyncContext;